import { render, staticRenderFns } from "./PackageType.vue?vue&type=template&id=221e2cb0"
import script from "./PackageType.vue?vue&type=script&lang=js"
export * from "./PackageType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports